const theme = {
    colors: {
        blue400: '#6988C5',
        blue300: '#909FD1',
        blue200: '#C2C9E8',
        blue100: '#DFE2EE',
        green400: '#4392A9',
        green300: '#6AA9B5',
        green200: '#9CD3CC',
        green100: '#B9ECD2',
        pink400: '#D374B8',
        pink300: '#FA89C4',
        pink200: '#FFB5DB',
        pink100: '#FFCEE1',
        orange400: '#E38A5A',
        orange300: '#FFA066',
        orange200: '#FFCC7C',
        orange100: '#FFE484',
        warm400: '#B80500',
        warm300: '#DE3A00',
        warm200: '#FF9A29',
        warm100: '#FFC236'
    }
}

export default theme;